export default __webpack_public_path__ + "static/amazon-removebg-preview-3da1912793393e83a3aea88e51ca216c.png";